<div class="footer">
    <span>© 2006-{{currentYear}} Eurofins Scientific</span>
</div>